import React from 'react'
import { Link } from "react-router-dom";

function Footer(){
    return (
        <>
         
    <footer className="pt-10 pb-4"  >

        <div className="footer-upper pb-4">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-4 pe-4">
                        <div className="footer-about">
                            <img src={`${process.env.PUBLIC_URL}/assets/images/logo.png`} className="" alt="" />
                            <p className="mt-3 mb-3 white">
                               At The Holiday Experts, we are dedicated to making your travel dreams a reality. Whether you're looking for flights, hotels, or bespoke travel packages. 
                            </p>
                            <ul>
                                <li className="white"><strong>PO Box:</strong> +47-252-254-2542</li>
                                <li className="white"><strong>Location:</strong> Collins Street, sydney, Australia</li>
                                <li className="white"><strong>Email:</strong> info@Travelin.com</li>
                                
                            </ul>
                        </div>
                    </div>
                     <div className="col-lg-2 col-md-6 col-sm-12 mb-4 footerLinksCol">
                        <div className="footer-links">
                            <h3 className="white">Our Services</h3>
                            <ul>
                              <li><Link to="/hotels">Hotels</Link></li>
                              <li><Link to="/holiday-packages">Holiday Packages</Link></li>
                              <li><Link to="/hajj-umrah">Hajj & Umrah</Link></li>
                              <li><Link to="/premium-flight">Premium</Link></li>
                              <li><Link to="/busines-flight">Business</Link></li>
                               <li><Link to="/first-class-flight">First Class</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-6 col-sm-12 mb-4 footerLinksCol">
                        <div className="footer-links">
                            <h3 className="white">Quick Links</h3>
                            <ul>
                                <li><Link to="/about-us">About Us</Link></li>
                                <li><Link to="/contact-us">Contact Us</Link></li>
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                <li><Link to="/terms-conditions">Terms &amp; Conditions</Link></li>
                                
                            </ul>
                        </div>
                    </div>
                   
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                        <div className="footer-links">
                            <h3 className="white">Newsletter</h3>
                            <div className="newsletter-form ">
                                <p className="mb-3">Subscribe to our newsletter for exclusive travel deals, expert tips, and inspiring destination guides. Stay updated on the latest offers for your next adventure!</p>
                                <form action="#" method="get"  className="border-0 d-flex align-items-center">
                                    <input type="email" placeholder="Email Address" />
                                    <button className="nir-btn ms-2 headerCallBtn">Subscribe</button>
                                </form>
                            </div> 
                        </div>  
                    </div>
                </div>
            </div>
        </div>

       

        <div className="footer-copyright">
            <div className="container">
                <div className="copyright-inner rounded p-3 d-md-flex align-items-center justify-content-between">
                    <div className="copyright-text">
                        <p className="m-0 white">2025 The Holiday Experts. All rights reserved.</p>
                    </div>
                    <div className="social-links">
                        <ul>  
                            <li><a href="#"><i className="fab fa-facebook" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i className="fab fa-twitter" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i className="fab fa-instagram" aria-hidden="true"></i></a></li>
                            <li><a href="#"><i className="fab fa-linkedin" aria-hidden="true"></i></a></li>
                        </ul>
                    </div>
                </div>    
            </div>
        </div>
        <div id="particles-js"></div>
    </footer>
    
    
    
    {/*<div id="back-to-top">
        <a href="#"></a>
    </div>*/}
    
    <div className="sticky-footer">
        <Link to="/contact-us" className="footer-icon">
             <i className="fas fa-envelope"></i>
             
             <strong>Email</strong>
        </Link>
        <a href="tel:+1234567890" className="footer-icon">
            <i className="fas fa-phone"></i>
            
            <strong>Phone</strong>
        </a>
        <a href="https://wa.me/1234567890" target="_blank" className="footer-icon">
            <i className="fab fa-whatsapp"></i>
            
            <strong>Whats App</strong>
        </a>
        <a
            onClick={() => {
            const shareText = `Check this out: `;
            if (navigator.share) {
            navigator.share({
                title: "Flight Details",
                text: shareText,
                url: window.location.href, // You can replace this with a flight-specific URL
            });
            } else {
            alert("Sharing not supported on this browser.");
            }
            }}
            className="footer-icon"
            >
            <i className="fas fa-share-alt"></i>
            
            <strong>Share</strong>
        </a>
    </div>


        </>
    )
}
export default   Footer;      